
<template>
    <div>
        <el-form :model="ruleForm"  style="width: 240px" ref="ruleForm" size="medium">
            <el-form-item  prop="mobile">
                <el-input  placeholder="手机号" maxlength="11" v-model="ruleForm.mobile"></el-input>
            </el-form-item>
            <el-form-item  prop="code">
                <el-input  placeholder="验证码" v-model="ruleForm.verifyCode">
                    <el-button @click="openModal" :disabled="btnFlag" slot="append">{{codeText}}</el-button>
                </el-input>
            </el-form-item>
            <el-form-item  prop="password">
                <el-input show-password placeholder="新密码" type="password" v-model="ruleForm.password"></el-input>
            </el-form-item>
            <el-form-item>
                <div style="display: flex;justify-content: space-between">
                    <el-button  @click="goLogin">返回</el-button>
                    <el-button @click="handleSubmit" :loading="submitLoading" type="primary">保存密码</el-button>
                </div>

            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="imgModal" title="图形码验证" width="25%" @close="handleClose">
            <el-input style="width: 100%;"  size="medium"  placeholder="图形码" v-model="imgCode">
                <img class="images" style="height: 30px" slot="append" :src="imgPic" alt="" @click="updataimg()">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="imgModal = false">取 消</el-button>
                <el-button size="medium" type="primary" :loading="btnLoading" @click="submitImgCode">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    // import {Session} from "../../../h5_src/framework/Session";

    import GcCmpVsSubmitButton from "../../../group-cloud/components/vsButton.submit";
    import GcCmpVsVerifyButton from "../../../group-cloud/components/vsButton.verify";
    import GcCmpVsInput from "../../../group-cloud/components/vsInput";
    import {ServerProdApidl} from '../../../../src/group-cloud/network/ServerBizApi';
    export default {
        name: 'gc-login-recover-password-form',
        components: {GcCmpVsVerifyButton, GcCmpVsSubmitButton, GcCmpVsInput},
        data () {
            return {
                list:[],
                submitLoading:false,
                btnLoading:false,
                btnFlag:false,
                imgModal:false,
                mobile: '',
                verify_code: '',
                new_password: '',
                imgCode:'',
                codeText:'发送验证码',
                imgPic:'',//图形码路径
                ruleForm:{
                    mobile:'',
                    verifyCode:'',
                    password:'',
                },
            }
        },
        computed: {

        },
        methods: {
            //打开图形码弹窗
            openModal(){
                let pattern =/^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
                if(this.ruleForm.mobile == ''){
                    this.$message.error('请先输入手机号');
                    return false;
                }
                // if(!pattern.test(this.ruleForm.mobile)){
                //     this.$message.error('请输入合法的手机号码');
                //     return false;
                // }
                this.updataimg();
                this.imgModal = true;
            },
            goLogin() {
                this.$router.push('/pages/login').catch(() => {})
            },
            handleClose(){
                this.updataimg();
                this.imgCode = '';
            },
            updataimg(){
                this.imgPic='/dataone-auth/images/captcha?'+Math.random();
            },
            //发送图形码校验
            async submitImgCode(){
                this.btnLoading = true;
                let url = 'verifyCode/send';
                let data = {
                    verifyCode:this.imgCode,
                    mobile:this.ruleForm.mobile
                }
                let res = await ServerProdApidl.send(url, data);
                if(res.code === 200){
                    this.getCode();
                    this.imgModal = false;
                }else{
                    this.$message.error(res.error);
                }
                this.btnLoading = false;
            },
            //发送验证码
            getCode(){
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.codeText = TIME_COUNT;
                    this.btnFlag = true;
                    this.timer = setInterval(() => {
                        if (this.codeText > 0 && this.codeText <= TIME_COUNT) {
                            this.codeText--;
                        } else {
                            clearInterval(this.timer);
                            this.timer = null;
                            this.codeText = '发送验证码';
                            this.btnFlag = false;
                        }
                    }, 1000)
                }
            },
            //提交新密码
            async handleSubmit(){
                let pattern =/^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
                if(this.ruleForm.mobile == ''){
                    this.$message.error('请先输入手机号');
                    return false;
                }
                if(!pattern.test(this.ruleForm.mobile)){
                    this.$message.error('请输入合法的手机号码');
                    return false;
                }
                if(this.ruleForm.password == ''){
                    this.$message.error('请输入新密码');
                    return false;
                }
                if(this.ruleForm.code == ''){
                    this.$message.error('请输入短信验证码');
                    return false;
                }
                if (!(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{6,20}$/.test(this.ruleForm.password))) {
                    this.$message.error('密码长度为6-20位，必须输入字母、以及大小写字母三种');
                    return false
                }
                this.submitLoading = true;
                // this.ruleForm.code = Number(this.ruleForm.code);
                let url = 'resetPasswd';
                let res = await ServerProdApidl.send(url, this.ruleForm);
                if(res.code === 200){
                    this.$message.success('保存成功')
                    this.goLogin();
                }else{
                    this.$message.error(res.message)
                }
                this.submitLoading = false;

            }
        }, // methods
        mounted() {

        }
    }
</script>
